/**
 * O que a prova da notificação (`OB-08`, ADR-071) usa na tela e o teste confere, fora dos
 * componentes — a recarga a quente do Vite só funciona em arquivo que exporta só componente.
 *
 * **A tela não decide nada**: a situação de cada etapa, o dia e se a tentativa prova vêm do
 * servidor, pela regra do domínio (`transit_domain.protocolo`). Aqui só a cor de cada
 * situação — e o texto vai sempre junto dela (§6).
 */
import type { EtapaNoDossie, TentativaNoDossie } from "../api/tipos";
import type { Significado } from "../componentes/tinta";

export const COR_DA_SITUACAO: Record<EtapaNoDossie["situacao"], Significado> = {
  CUMPRIDA: "verde",
  DISPENSADA: "azul",
  NAO_EXIGIDA: "cinza",
  ANTES_DO_DIA: "cinza",
  NO_DIA: "amarelo",
  EM_FALTA: "vermelho",
  AGUARDA_O_AUTO: "cinza",
};

/** O dia da etapa como a norma o escreve: dd/mm/aaaa, em Brasília. */
export function diaDaEtapa(etapa: EtapaNoDossie): string | null {
  if (!etapa.dia_inicio) return null;
  return new Date(etapa.dia_inicio).toLocaleDateString("pt-BR", {
    timeZone: "America/Sao_Paulo",
  });
}

/** "WhatsApp · 09/10/2026 10:00 · WA-1" — a prova numa linha. */
export function resumoDaTentativa(t: TentativaNoDossie): string {
  const quando = new Date(t.realizada_em).toLocaleString("pt-BR", {
    timeZone: "America/Sao_Paulo",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
  return `${t.canal_rotulo} · ${quando} · ${t.recibo}`;
}

/** O modelo da planilha do provedor: as colunas que o servidor lê, com dois exemplos. */
export const MODELO_DA_PLANILHA_DE_NOTIFICACOES = [
  "passagem;etapa;canal;data;recibo;resultado",
  "t-0001;8;e-mail;09/10/2026 10:15;MSG-12345;entregue",
  "t-0001;15;sms;16/10/2026 09:02;SMS-98765;enviada",
].join("\n");
